import React from 'react';
import LwtApp from '@lwtears/lwt-common-frontend/lib/LwtApp';
import SettingsApi from '@lwtears/lwt-common-frontend/lib/@api/settings-api';
import AppProviders from './app/AppProviders';
import GatedApp from './app/GatedApp';
import translationEN from './translations/EN.json';
import translationES from './translations/ES.json';

const config = {
  api: { saveSettings: SettingsApi.saveStudentSettings },
  i18n: {
    resourceMap: {
      'en-US': {
        gss: translationEN
      },
      'es-US': {
        gss: translationES
      }
    }
  }
};

const App = () => (
  <LwtApp {...config}>
    <AppProviders>
      <GatedApp />
    </AppProviders>
  </LwtApp>
);

export default App;
